import React from 'react';
import { useTranslation } from 'react-i18next';
import ExportCSVInvoices from './ExportCSVInvoices';

function ExportCSVRow({ data = [], text }) {
  const [t] = useTranslation();

  if (data.length === 0) return null;
  return (
    <li>
      {text}: {data.length} <ExportCSVInvoices data={data} />
    </li>
  );
}

export default ExportCSVRow;
